import { format } from 'date-fns'

import { GolfTournament } from '@img-arena/consoles-api-dde'
import { DataCardDetailsEntry } from '@/components/card'

export const TOURNAMENT_TABS = {
  LEADERBOARD: 'leaderboard',
  ODDS_DATA: 'odds-data'
} as const

export type TournamentTabType = (typeof TOURNAMENT_TABS)[keyof typeof TOURNAMENT_TABS]

export const createTournamentTabs = () => [
  { value: TOURNAMENT_TABS.LEADERBOARD, label: 'Leaderboard' },
  { value: TOURNAMENT_TABS.ODDS_DATA, label: 'Odds Data' }
]

export const getTournamentHeaderItems = (
  tournament: GolfTournament | null | undefined
): DataCardDetailsEntry[] => {
  return [
    {
      key: 'Start date',
      value: tournament?.startTeeTime
        ? format(new Date(tournament?.startTeeTime), 'MMM dd, yyyy HH:mm')
        : '-'
    },
    {
      key: 'Location',
      value: tournament?.venue || '-'
    },
    {
      key: 'UTC',
      value: tournament?.utcOffset !== undefined ? tournament.utcOffset : '-'
    },
    {
      key: 'Tournament ID',
      value: tournament?.id || '-',
      copyable: true
    }
  ]
}
